module.exports = __webpack_public_path__ + "static/media/Bali Lagi-Lagi.33657222.png";